import { useEffect, useState } from "react";
import { Loader2, Building2 } from "lucide-react";
import { api } from "@/lib/api";

export const AdminCommercialPlans = () => {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    api.get("/admin/commercial-plans").then((r) => setPlans(r.data.plans)).catch(() => setPlans([]));
  }, []);

  let body;
  if (plans === null) {
    body = <Loader2 className="w-6 h-6 text-brand animate-spin" />;
  } else if (plans.length === 0) {
    body = <p data-testid="admin-commercial-plans-empty" className="text-sm text-zinc-600">No commercial plan requests yet.</p>;
  } else {
    body = (
      <ul className="divide-y divide-zinc-100">
          {plans.map((p) => (
            <li key={p.id} data-testid={`admin-commercial-plan-${p.id}`} className="py-4 first:pt-0 last:pb-0">
              <div className="flex flex-wrap justify-between gap-2">
                <p className="font-medium text-brand-ink">{p.business_name} <span className="text-zinc-500 font-normal">({p.business_type})</span></p>
                <span className="text-xs text-zinc-500">{p.created_at?.slice(0, 10)}</span>
              </div>
              <p className="text-sm text-zinc-600 mt-0.5">{p.contact_name} · {p.phone} · {p.email}</p>
              <p className="text-sm text-zinc-600 mt-0.5">{p.address} · {p.num_units} unit(s){p.system_types ? ` · ${p.system_types}` : ""} · {p.service_frequency} service</p>
              {p.concerns && <p className="text-sm text-zinc-500 mt-0.5">"{p.concerns}"</p>}
              {p.callback_time && <p className="text-xs text-zinc-500 mt-0.5">Preferred callback: {p.callback_time}</p>}
            </li>
          ))}
        </ul>
    );
  }

  return (
    <div data-testid="admin-commercial-plans-card" className="bg-white border border-zinc-200 p-6 rounded-sm mt-6">
      <h2 className="font-heading font-bold text-lg text-brand-ink mb-4 flex items-center gap-2">
        <Building2 className="w-5 h-5 text-brand" /> Commercial Plan Requests (Admin)
      </h2>
      {body}
    </div>
  );
};
